// Filtro de búsqueda para los Select de antd: compara contra el texto visible de la opción aunque sea
// un arreglo o tenga elementos (Tooltip, Tag...). Sin distinguir mayúsculas ni tildes.

const textoNodo = (nodo) => {
  if (nodo === null || nodo === undefined || typeof nodo === "boolean") return "";
  if (typeof nodo === "string" || typeof nodo === "number") return String(nodo);
  if (Array.isArray(nodo)) return nodo.map(textoNodo).join("");
  if (typeof nodo === "object" && nodo.props) return textoNodo(nodo.props.children);
  return "";
};

// Texto de una opción: sus hijos (texto completo) o, si no tiene, su label
export const textoOpcion = (option) => {
  if (!option) return "";
  const hijos = textoNodo(option.children);
  return hijos || textoNodo(option.label);
};

const normalizar = (texto) =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

export const filtrarOpcion = (input, option) =>
  normalizar(textoOpcion(option)).includes(normalizar(input).trim());
